module.exports = __webpack_public_path__ + "static/media/elife-news-50x-coins.99ba661e.png";